var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 -6 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_25.Camera-Front",
    "data-name": "25.Camera-Front",
    d: "M43,41H5a4,4,0,0,1-4-4V15a4,4,0,0,1,4-4H6A2,2,0,0,1,8,9h2a2,2,0,0,1,2,2h2a3.7,3.7,0,0,0,2-1l2-2a2.781,2.781,0,0,1,2-1h8a2.549,2.549,0,0,1,2,1l2,2a3.7,3.7,0,0,0,2,1h9a4,4,0,0,1,4,4V37A4,4,0,0,1,43,41Zm2-26a2,2,0,0,0-2-2l-9.221-.013a5.632,5.632,0,0,1-3.193-1.573l-2.13-2.13-.1-.151A.6.6,0,0,0,28,9H20a.817.817,0,0,0-.424.231l-.075.1-2.087,2.086a5.63,5.63,0,0,1-3.193,1.573l-4.151.006c-.024,0-.047.008-.07.008H8c-.014,0-.026,0-.04,0L5,13a2,2,0,0,0-2,2V37a2,2,0,0,0,2,2H43a2,2,0,0,0,2-2ZM24,37A11,11,0,1,1,35,26,11,11,0,0,1,24,37Zm0-20a9,9,0,1,0,9,9A9,9,0,0,0,24,17Zm0,14a5,5,0,1,1,5-5A5,5,0,0,1,24,31Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,24,23ZM10,19H6a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v2A1,1,0,0,1,10,19Z",
    transform: "translate(-1 -7)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d2ac169d4b2a4154d7a0cc2a3d6f30e1.svg";
export { ForwardRef as ReactComponent };